<template>
  <div id="pageRoot">

    <span class="normalTheme pageInstruction" style="left: 90px; top: 50px;">
      <p>Escribe otra palabra que rime y luego dibújala.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 90px; top: 90px;">
      <p>Sube fotos de tus dibujos.</p>
    </span>

    <div 
    style="
    position: absolute;
    background-color: #ED1C24;
    width: 240px;
    height: 50px;
    top: 133px;
    left: 115px;
    ">
    <p class="textBase center" style="color: white; font-size: 32px;">AMARILLA</p>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <div id="button01" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
      ></image-upload>
    </div>

    <div 
    style="
    position: absolute;
    background-color: #ED1C24;
    width: 240px;
    height: 50px;
    top: 133px;
    left: 395px;
    ">
    <p class="textBase center" style="color: white; font-size: 32px;">CANTAR</p>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
    ></uploaded-image>
    <div id="button02" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
      ></image-upload>
    </div>

    <div 
    style="
    position: absolute;
    background-color: #ED1C24;
    width: 240px;
    height: 50px;
    top: 133px;
    left: 670px;
    ">
    <p class="textBase center" style="color: white; font-size: 32px;">BERRO</p>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <uploaded-image
      class="image03 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
    ></uploaded-image>
    <div id="button03" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="3"
      ></image-upload>
    </div>

  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 88px;
  top: 41px;
}
#inputField01 {
  position: absolute;
  width: 218px;
  height: 31px;
  left: 115px;
  top: 197px;
  z-index: 5;
}
#inputField02 {
  position: absolute;
  width: 218px;
  height: 31px;
  left: 395px;
  top: 197px;
  z-index: 5;
}
#inputField03 {
  position: absolute;
  width: 218px;
  height: 31px;
  left: 671px;
  top: 197px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 238px;
  height: 320px;
  left: 116px;
  top: 262px;
}
.image02 {
  position: absolute;
  width: 238px;
  height: 320px;
  left: 395px;
  top: 262px;
}
.image03 {
  position: absolute;
  width: 238px;
  height: 320px;
  left: 673px;
  top: 262px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 138px;
  top: 553px;
}
#button02 {
  width: 216px;
  height: 77px;
  left: 413px;
  top: 553px;
}
#button03 {
  width: 216px;
  height: 77px;
  left: 694px;
  top: 553px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p68-69/V45.mp4", "p68-69/V46.mp4"]
    }
  }
}
</script>